/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Smarts Conversation UI
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import { shrinkTempModule } from './Utils'


export function VisRecommenderAPI({ logger, SmartsAPI }){

	function getRequestPayload(
		includedCharts,
		hasSmartModule,
		requestParams
	){
		const { oneChartPerType, sourceModuleId, sourceType, columns, numResults, hasShaping, tempModuleObject } = requestParams

		let payload = {
			sourceModuleId,
			sourceType,
			columns,
			oneChartPerType,
			numResults: numResults || 10,
			shapedModule: !!hasShaping
		}

		if( includedCharts !== null ){
			payload.includedCharts = includedCharts
		}

		if( hasShaping ||  !hasSmartModule ){
			const columnIds = columns.reduce( (acc, { id }) => {
				if( id && id.length ){
					return acc.concat(id)
				}
			}, [])
			const newModule = shrinkTempModule(columnIds, tempModuleObject, logger)
			payload.tempModule = newModule.toJSON()
		}

		return payload
	}

	function recommend( requestParams ){

		const { sourceModuleId, chartsToInclude } = requestParams
		let promises = [SmartsAPI.getSmartModuleProgressSummary(sourceModuleId)]
		if( chartsToInclude ) {
			promises.push(SmartsAPI.getSupportedChartTypes(chartsToInclude))
		}

		return Promise.all( promises )
			.then( resolvedPromises  => {
				const includedAndSupportedCharts = chartsToInclude ? resolvedPromises[1] : null
				const hasSmartModule = resolvedPromises[0].status.toUpperCase() === 'DONE'

				return getRequestPayload(
					includedAndSupportedCharts,
					hasSmartModule,
					requestParams
				)
			})
			.then(payload => SmartsAPI.getVisRecommendation(payload))
	}

	return {
		recommend
	}
}

